import {
  itemLocationRecordUrl,
  itemSelectListUrl,
  parametersSelectListUrl,
  parametersSelectListForMetersUrl,
  partParameterDataUrl,
  equipmentItemParametersUrl,
  parameterListForItemUrl,
} from "../helpers/apiUrls";
import { makeRequest } from "../helpers/makeRequest";
import { isEmptyObject, prepareUrlWithQueryParams } from "../helpers/methods";
import useAxiosPrivate from "../hooks/useAxiosPrivate";

export default function useItemService() {
  const axiosPrivate = useAxiosPrivate();

  const getItemsSelectList = (searchParams = undefined) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(itemSelectListUrl, searchParams)
    );
  };


  const getEmptyItemLevel = (parent = null, level = 1) => {
    return {
      parent: parent,
      level: level,
    };
  };

  const getItemRecordById = (itemId) => {
    return makeRequest(axiosPrivate, itemLocationRecordUrl(itemId));
  };

  const getEmptyItemElement = (parent = null, level = 1) => {
    return [getEmptyItemLevel(parent, level)];
  };

  const getParametersList = (searchParams) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(parametersSelectListUrl, searchParams)
    );
  };

  const getParametersListForMeters = (searchParams) => {
    return makeRequest(
      axiosPrivate,
      prepareUrlWithQueryParams(parametersSelectListForMetersUrl, searchParams)
    );
  };

  const getPartParametersList = (partId) => {
    return makeRequest(axiosPrivate, partParameterDataUrl(partId));
  };

  const getEquipmentParametersList = (equipmentId) => {
    return makeRequest(axiosPrivate, equipmentItemParametersUrl(equipmentId));
  };

  const prepareItemDataFromBackendForItemRecordComponent = (
    item,
    addEmptyLevel = true
  ) => {
    if (!item || isEmptyObject(item)) return getEmptyItemElement();

    let preparedItem = item;
    preparedItem = Object.values(item)
      .filter((level) => level !== null)
      .map((level, idx) => ({
        id: level.id,
        parent: level.item_parent,
        level: idx,
      }));

    if (addEmptyLevel && preparedItem.length) {
      preparedItem = [
        ...preparedItem,
        getEmptyItemLevel(
          preparedItem[preparedItem.length - 1].id,
          preparedItem.length
        ),
      ];
    }

    return preparedItem;
  };

  const getParametersListForItem = (itemId) => {
    return makeRequest(axiosPrivate, parameterListForItemUrl(itemId));
  };


  return {
    getItemsSelectList,
    getEmptyItemElement,
    getParametersList,
    getParametersListForMeters,
    getPartParametersList,
    prepareItemDataFromBackendForItemRecordComponent, 
    getItemRecordById,
    getEquipmentParametersList, 
    getParametersListForItem
  };
}
